import { message } from 'ant-design-vue';

const WARNING_DURATION_SECONDS = 8;

/**
 * Показывает результат отклонения планировки: ушло ли заказчику уведомление.
 *
 * Бэк отдаёт customer_notification в ответе POST /api/crm/plans/{id}/decline.
 * Отклонение проходит всегда, а уведомление — только если у заказчика настроен
 * исходящий вебхук со стратегией declined.
 *
 * @param {{ sent: boolean, reason: ?string }} [notification]
 */
export default function showDeclineNotificationResult(notification) {
  if (notification?.sent) {
    message.success('Планировка отклонена, заказчику отправлено уведомление');
    return;
  }

  const reason = notification?.reason ?? 'причина неизвестна';

  message.warning(`Планировка отклонена, но заказчик не уведомлён: ${reason}`, WARNING_DURATION_SECONDS);
}
